import ArticleSections from './ArticleSections';
import QuizList from './QuizList';
import { buildReactionArticleSections } from '../utils/articleUtils';

/**
 * The long write-up under a famous reaction's result: what you'd see, why, real life, history,
 * a safe activity and a quiz.
 */
export default function ReactionArticle({ article }) {
  return (
    <>
      <ArticleSections sections={buildReactionArticleSections(article)} />
      <QuizList quiz={article.quiz} />
    </>
  );
}
